import React from "react";
import styled from "styled-components";
import Product from "./Product";

const GridView = ({ products }) => {
  return (
    <Wrapper>
      <div className="products-container">
        {products.map((product) => {
          return <Product key={product.imgName} {...product} />;
        })}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .products-container {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }

  @media (min-width: 776px) {
    .products-container {
      gap: 2.5rem 2rem;
    }
  }
`;

export default GridView;
